/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { hideModal } from "actions";
import "components/elements/modal/ModalDialog.css";

const ModalDialog = (props) => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  // console.log(props.modal);
  return (
    <Modal
      show={props.modal.showModal}
      onHide={props.hideModal}
      id={props.modal.modalElementId}
      dialogClassName={props.modal.modalCustomClassName}
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.modal.modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.modal.modalContent}</Modal.Body>
      {props.modal.modalFooter ? (
        <Modal.Footer>{props.modal.modalFooter}</Modal.Footer>
      ) : null}
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { hideModal })(ModalDialog);
